/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonDatetime, ModalController, PickerController } from '@ionic/angular';
import { DataService } from '../../services/data.service';
import { Activity } from '../../shared/models';

@Component({
  selector: 'app-activity-form',
  templateUrl: './activity-form.component.html',
  styleUrls: ['./activity-form.component.scss'],
})
export class ActivityFormComponent implements OnInit {

  @ViewChild(IonDatetime, { static: true }) datetime: IonDatetime;

  activity: Partial<Activity> = {
    name: undefined,
    type: 'Run',
    start_date_local: new Date(),
    moving_time: 3600,
    elapsed_time: 3600,
    distance: 10000,
    pace:0
  };
  hours = 1;
  minutes = 0;
  seconds= 0;

  options = [
    'AlpineSki', 'BackcountrySki', 'Canoeing', 'Crossfit', 'EBikeRide',
    'Elliptical', 'Golf', 'Handcycle', 'Hike', 'IceSkate', 'InlineSkate',
    'Kayaking', 'Kitesurf', 'NordicSki', 'Ride', 'RockClimbing', 'RollerSki',
    'Rowing', 'Run', 'Sail', 'Skateboard', 'Snowboard', 'Snowshoe', 'Soccer',
    'StairStepper', 'StandUpPaddling', 'Surfing', 'Swim', 'Velomobile',
    'VirtualRide', 'VirtualRun', 'Walk', 'WeightTraining', 'Wheelchair',
    'Windsurf', 'Workout', 'Yoga'
  ];

  pickerButtons = [
    {
      text: 'Cancel',
      role: 'cancel',
    },
    {
      text: 'Confirm',
      handler: (value) => {
        this.calculate(value);
      },
    },
  ];

  constructor(private modalController: ModalController, private dataService: DataService, private pickerController: PickerController) { }

  ngOnInit() {
  }

  save(){
    this.dismiss(this.activity);
  }

  dismiss(data) {
    if (data){
      data.elapsed_time = data.moving_time ?? 6000;
    }
    this.modalController.dismiss({
      type:'activity',
      data
    });
  }

  calculate(value){
    this.hours = value.hours.value;
    this.minutes = value.minutes.value;
    this.seconds = value.seconds.value;
    this.activity.moving_time = (this.hours*60*60)+(this.minutes)*60+this.seconds;
    this.activity.pace = this.dataService.calculatePace(this.activity.distance, this.activity.moving_time);
  }

  setDate(event){
    this.activity.start_date_local = new Date(event);
  }

  async openPicker() {
    const hourSelection = {
      name:'hours',
      cssClass:'mainColumn',
      options: [],
      suffix:':',
      selectedIndex: this.hours
    };
    for (let i=0;i<100;i++){
      hourSelection.options.push({
        text: i<10 ? '0'+i : i.toString(),
        value:i,
        //selected: i===this.hours
      });
    }
    const minutes ={
      name:'minutes',
      options:[],
      cssClass:'mainColumn',
      suffix:':',
      selectedIndex: this.minutes
    };
    for (let x=0;x<60;x++){
      minutes.options.push({
        text: x<10 ? '0'+x : x.toString(),
        value:x,
       // selected: i===this.minutes
      });
    }
    const seconds ={
      name:'seconds',
      options:[],
      cssClass:'mainColumn',
      selectedIndex: this.seconds
    };
    for (let y=0;y<60;y++){
      seconds.options.push({
        text: y<10 ? '0'+y : y.toString(),
        value:y,
      //selected: i===this.seconds
      });
    }
    const picker = await this.pickerController.create({
      columns:  [hourSelection,minutes,seconds],
      buttons: this.pickerButtons
    });
    await picker.present();
  }


}
